export default __webpack_public_path__ + "static/media/08.c9923a4e.mp3";